<template>
      <iframe
          :src="pdfUrl"
          width="100%"
          height="600px"
          frameborder="0"
          scrolling="no"
          :title="$translate('ETCeresCoconut::Template.etcAllgemeinArtikelProduktdatenblatt')"
          @load="onLoad"
      ></iframe>
</template>

<script>
export default {
  name: "lazy-pdf-viewer",
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    onLoad() {
      console.log("PDF geladen:", this.pdfUrl);
    },
  },
};
</script>
